var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticStyle:{"width":"100%"}},[(_vm.isMobile)?_c('router-view'):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }